// src/pages/admin/ColorEditor.jsx
import { Link } from "react-router-dom";
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../../firebase";
import { colorThemes as useVenueTheme } from "../../hooks/useTheme";
import { useRequireAuth } from "../../hooks/useRequireAuth";
import { useVenueName } from "../../hooks/useVenueName";
export default function ColorEditor() {
  const { name, } = useVenueName();
  useRequireAuth()
  // Mapa kolorów – klucz to nazwa zapisywana w Firebase, wartość to pełne klasy Tailwind


  const [chosenColorKey, setChosenColorKey] = useState("emeraldRoyal");
  const [saving, setSaving] = useState(false);
  const [status, setStatus] = useState(null);

  // Aktualny motyw na podstawie wybranego klucza
  const theme = useVenueTheme[chosenColorKey] || useVenueTheme.emeraldRoyal;

  // Pobierz z Firebase
  useEffect(() => {
    if (!name) return;
    const fetchColor = async () => {
      const chosenRef = doc(db, "venues", name, "defaults", "chosen");
      const snap = await getDoc(chosenRef);
      if (snap.exists() && snap.data().color && useVenueTheme[snap.data().color]) {
        setChosenColorKey(snap.data().color);
      } else {
        await setDoc(chosenRef, { color: "emerald" });
      }
    };
    fetchColor();
  }, [name]);

  // Zapisz do Firebase
  const saveColor = async () => {
    if (!name) return;
    setSaving(true);
    try {
      const chosenRef = doc(db, "venues", name, "defaults", "chosen");
      await updateDoc(chosenRef, { color: chosenColorKey });
      setStatus({ type: "success", message: "Kolor zapisany!" });
    } catch (err) {
      setStatus({ type: "error", message: "Błąd zapisu" });
    }
    setSaving(false);
    setTimeout(() => setStatus(null), 3000);
  };

 return (
  <div className="min-h-screen bg-gray-100 pt-20 px-4">
    <div className="max-w-5xl mx-auto bg-white shadow-2xl p-8 md:p-12 rounded-2xl">
      <Link to={`/${name}/admin`} className="inline-block mb-8 text-blue-600 hover:underline text-lg">
        ← Wróć do panelu administracyjnego
      </Link>

      <h1 className="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-6">
        Edytor głównego koloru strony
      </h1>
      <p className="text-center text-gray-600 text-lg mb-12 max-w-3xl mx-auto">
        Wybierz motyw kolorystyczny – będzie używany w przyciskach, nagłówkach, sekcjach CTA i akcentach na całej stronie klienta.
      </p>

      {/* Wybór koloru */}
      <div className="mb-16">
        <h2 className="text-2xl md:text-3xl font-semibold text-center mb-10 text-gray-700">
          Wybierz motyw
        </h2>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-8 max-w-4xl mx-auto">
          {Object.entries(useVenueTheme).map(([key, color]) => (
            <button
              key={key}
              onClick={() => setChosenColorKey(key)}
              className={`group relative flex flex-col items-center transition-all duration-300 ${
                chosenColorKey === key ? "scale-110" : "hover:scale-105"
              }`}
              title={color.name}
            >
              {/* Kółko z gradientem */}
              <div
                className="w-24 h-24 rounded-full shadow-xl ring-8 transition-all duration-300"
                style={{
                  background: `linear-gradient(to bottom right, ${color.primary}, ${color.secondary})`,
                  ringColor: chosenColorKey === key ? "#1f2937" : "#e5e7eb",
                }}
              />

              {/* Wskaźnik wyboru */}
              {chosenColorKey === key && (
                <div className="absolute -bottom-3 left-1/2 transform -translate-x-1/2 w-8 h-8 bg-gray-800 rounded-full flex items-center justify-center">
                  <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
              )}

              <span className="mt-8 text-base md:text-lg font-medium text-gray-700 text-center">
                {color.name}
              </span>
            </button>
          ))}
        </div>
      </div>

      {/* Podgląd wybranego motywu */}
      <div className="mb-16">
        <h2 className="text-2xl md:text-3xl font-semibold text-center mb-10 text-gray-700">
          Podgląd wybranego motywu
        </h2>

        {/* Przykładowa sekcja CTA */}
        <div
          className="p-10 md:p-16 text-center text-white shadow-2xl rounded-3xl overflow-hidden"
          style={{
            background: `linear-gradient(to right, ${theme.primary}, ${theme.secondary})`,
          }}
        >
          <h3 className="text-3xl md:text-5xl font-bold mb-6">
            Zarezerwuj stolik już dziś!
          </h3>
          <p className="text-lg md:text-xl mb-10 opacity-90 max-w-2xl mx-auto">
            Nie czekaj – najlepsze miejsca szybko się rozchodzą. Zarezerwuj online w kilka sekund.
          </p>

          <button
            className="bg-white font-bold text-xl md:text-2xl px-10 py-5 rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
            style={{
              color: theme.primary,
            }}
          >
            Zarezerwuj teraz
          </button>
        </div>

        {/* Dodatkowe przykłady elementów */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
          <div className="bg-gray-50 p-8 rounded-xl text-center">
            <h4 className="font-semibold text-gray-700 mb-4">Przycisk główny</h4>
            <button
              className="px-8 py-4 rounded-lg text-white font-bold shadow-lg hover:shadow-xl transition transform hover:scale-105"
              style={{
                backgroundColor: theme.primary,
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = theme.secondary)}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = theme.primary)}
            >
              Akcja
            </button>
          </div>

          <div className="bg-gray-50 p-8 rounded-xl text-center">
            <h4 className="font-semibold text-gray-700 mb-4">Focus na inputach</h4>
            <input
              type="text"
              placeholder="Przykład pola"
              className="px-6 py-4 border-2 rounded-lg w-full focus:outline-none focus:ring-4 focus:ring-offset-2"
              style={{ "--tw-ring-color": theme.ring }}
            />
          </div>

          <div className="bg-gray-50 p-8 rounded-xl text-center">
            <h4 className="font-semibold text-gray-700 mb-4">Nagłówek z akcentem</h4>
            <h3 className="text-2xl font-bold" style={{ color: theme.primary }}>
              To jest wyróżniony tekst
            </h3>
          </div>
        </div>
      </div>

      {/* Zapisywanie */}
      <div className="text-center">
        <button
          onClick={saveColor}
          disabled={saving}
          className="bg-emerald-600 hover:bg-emerald-700 disabled:opacity-60 disabled:cursor-not-allowed text-white font-bold text-xl px-16 py-6 rounded-2xl shadow-2xl hover:shadow-3xl transition-all duration-300"
        >
          {saving ? "Zapisywanie motywu..." : "Zapisz wybrany motyw"}
        </button>

        {status && (
          <p
            className={`mt-8 text-xl font-semibold ${
              status.type === "success" ? "text-emerald-600" : "text-red-600"
            }`}
          >
            {status.message}
          </p>
        )}
      </div>
    </div>
  </div>
);
}